import { HttpErrorResponse } from '@angular/common/http';
import { TimeoutError } from 'rxjs';

/**
 * No usable answer from the server (offline, Funkloch, timeout): the request may or may not have reached it. With the
 * Angular service worker a failed fetch comes back as 504 «Gateway Timeout» instead of status 0; 502/503 come from the
 * proxy (review W3). Safe to retry with the same key and body.
 */
export function isNetworkError(error: unknown): boolean {
  if (error instanceof TimeoutError) return true;
  return error instanceof HttpErrorResponse && (error.status === 0 || error.status === 502 || error.status === 503 || error.status === 504);
}

/** safe label for a log line: HTTP status or error name, never the error object (may carry personal data) */
export function errorLabel(error: unknown): string | number {
  if (error instanceof HttpErrorResponse) return error.status;
  return error instanceof Error ? error.name : 'unknown';
}
